import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=06470eaa&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=06470eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06470eaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06470eaa')) {
      api.createRecord('06470eaa', component.options)
    } else {
      api.reload('06470eaa', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=06470eaa&scoped=true&", function () {
      api.rerender('06470eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PdljHn5WMR91/JS/teamMember.vue"
export default component.exports